import BaseService from './BaseService'
import entities from 'src/config/entities'

class ClientUserService extends BaseService {

  constructor () {
    super({entity: entities.CLIENT_USER})
  }

  async activateClientUser(id) {
    try {
      let res = await this.instance.put(`/${id}/switch`, {})
      return res.data
    } catch (e) {
      this._handleError({ translationKey: 'client.switch.error', error: e });
      throw e;
    }
  }
 }

export default new ClientUserService()
